import { Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import axios from 'axios';
import BackButton from '../../../utils/backButton';
import { useStyles } from '../styles';
import { HelpComponent } from '../../../utils/helpComponent';
import HELP_URL from '../../../utils/helpLinkConstant';
import ReusableCards from './ReusableCards';
import StatusPage from './StatusPage';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import { useLocation, useNavigate } from 'react-router';
import { useTickets } from '../hooks/useTickets';
import { useGetAllTickets } from '../hooks/useGetAllTickets';

const TicketDetails = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const { ticketId, ticketNumber, description, jsonUrl } = location.state;
  const [parsedJson, setParsedJson] = useState(null);

  React.useEffect(() => {
    if (!ticketId || !ticketNumber || !description) {
      navigate('/manage-permit-build', {
        state: { refresh: true },
      });
    }
  },[ticketId, ticketNumber, description]);

  const fetchFile = async () => {
    const response = await axios.get(jsonUrl, { responseType: 'blob' });
    const fileReader = new FileReader();

    fileReader.onload = (event) => {
      const fileContent = event.target?.result;
      if (fileContent) {
        try {
          const parsedContent = JSON.parse(fileContent as string);
          setParsedJson(parsedContent);
        } catch (error) {
          console.error('Error parsing file content:', error);
        }
      }
    };

    fileReader.onerror = (error) => {
      console.error('Error reading file:', error);
    };

    fileReader.readAsText(response.data);
    const test = axios.get(jsonUrl);
    if (test) {
      console.log(test)
    }
  }

  React.useEffect(() => {
    console.log('jsonUrl:', jsonUrl);
    if (jsonUrl) {
      fetchFile();
    }
  },[jsonUrl])

  const [currentView, setCurrentView] = useState('ReusableCards');
  const [formData, setFormData] = useState({});
  const [selectedAssets, setSelectedAssets] = useState([]);
  const { batchSaveAssets } = useTickets(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const { refreshTickets } = useGetAllTickets(true);

  const handleSelectionChange = (assets: any) => {
    setSelectedAssets(assets);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await batchSaveAssets(ticketNumber, selectedAssets);
      navigate('/manage-permit-build', {
        state: { refresh: true },
      });
    } catch (error) {
      console.error('Error saving assets:', error);
    }
  };

  const handleReset = () => {
    setSelectedAssets([]);
    setCurrentView('ReusableCards');
    setResetTrigger(prev => !prev); // Add this state
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.header}>
        <div>
          <ConfirmationNumberOutlinedIcon />
        </div>
        <div>
          <div>Ticket number: #{ticketNumber}</div>
          <div>{description}</div>
        </div>
      </div>
      <div className={classes.pagePadding}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.flexSpacebetween}
          >
            <BackButton />
            <HelpComponent
              helpUrl={HELP_URL.PERFORMANCE_TEST_MANAGECONFIG_PAGE}
            />
          </Grid>
        </Grid>
        <div className={classes.content}>
          {currentView === 'ReusableCards' ? (
            <ReusableCards
              ticketId={ticketId}
              ticketNumber={ticketNumber}
              setCurrentView={setCurrentView}
              onSelectionChange={handleSelectionChange}
              resetTrigger={resetTrigger}
              parsedJson={parsedJson}
            />
          ) : (
            <StatusPage ticketId={ticketId} ticketNumber={ticketNumber} />
          )}
        </div>
      </div>
      {/* <Grid container className={classes.footer} spacing={0}>
        <Grid item xs={12} className={classes.footerButtons}>
          <Button
            variant="outlined"
            onClick={handleReset}
            className={classes.resetButton}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            className={classes.submitButton}
          >
            Submit
          </Button>
        </Grid>
      </Grid> */}
    </form>
  );
};

export default TicketDetails;
